export function pct(rate) { return `${Math.round(rate * 100)} %`; }

export function scoreLabel(s) {
  if (s >= 0.9) return "excellent";
  if (s >= 0.7) return "good";
  if (s >= 0.5) return "partial";
  return "low";
}

// Score band → design-system badge tone (ds-badge--<tone>).
const SCORE_TONES = { excellent: "success", good: "success", partial: "warning", low: "danger" };

export function scoreTone(s) {
  return SCORE_TONES[scoreLabel(s)];
}

export const MATCHING_TAB = { SUPPLY: "supply", MISSING: "missing" };

// Can supply / Missing tabs for a matching report. Counts come from the summary
// and fall back to the row arrays for older snapshots without one.
export function matchingResultTabs(report = {}) {
  const summary = report.summary || {};
  return [
    {
      key: MATCHING_TAB.SUPPLY,
      label: "Can supply",
      count: summary.can_supply ?? (report.can_supply || []).length,
    },
    {
      key: MATCHING_TAB.MISSING,
      label: "Missing",
      count: summary.missing ?? (report.missing || []).length,
    },
  ];
}
